function defaultSearchFunction (item, searchQuery, component) {
  const textMatch = item[component.textAttr || 'name'].toLowerCase().includes(searchQuery.toLowerCase());
  return textMatch;
}

export default defaultSearchFunction;
